"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugPanelTemplate = void 0;
var tslib_1 = require("tslib");
var debug_panel_dot_1 = (0, tslib_1.__importDefault)(require("./debug-panel.dot"));
var debugPanelTemplate = debug_panel_dot_1.default.default ? debug_panel_dot_1.default.default : debug_panel_dot_1.default;
exports.debugPanelTemplate = debugPanelTemplate;
//# sourceMappingURL=index.js.map